// ./src/utils/personAvatar.ts
//
// One place that turns a resolved Person (or any {avatarUploadedFile, avatarGravatarUrl})
// into a display avatar URL. The BE already did the work — the uploaded avatar file
// (via ms_storage) and the Gravatar fallback are both resolved server-side on the
// Person type — so callers just read data. Reuse this everywhere a contact/person
// avatar is shown (guests, partners, contacts…) instead of re-deriving the fallback.

export interface PersonAvatarSource {
  /** The uploaded avatar resolved from ms_storage (Person.avatarUploadedFile). */
  avatarUploadedFile?: { fileUrl?: string | null } | null;
  /** The server-computed Gravatar fallback (Person.avatarGravatarUrl). */
  avatarGravatarUrl?: string | null;
}

/** A person's display avatar URL: the uploaded avatar, else the Gravatar fallback,
 *  else null. Both are pre-resolved by the BE Person resolver. */
export const personAvatarUrl = (p: PersonAvatarSource | null | undefined): string | null =>
  p?.avatarUploadedFile?.fileUrl || p?.avatarGravatarUrl || null;
